import { createStore } from 'vuex';
import user from './modules/user';
import serviceHappy from './modules/serviceHappy';
import unBind from './modules/unBind';
import serviceRepair from './modules/serviceRepair';
import yearReport from './modules/yearReport';
import yearReport2022 from './modules/yearReport2022';
import yearReport2024 from './modules/yearReport2024';
import yearReport2025 from './modules/yearReport2025';
import invoice from './modules/invoice';
import { SET_TITLE, SET_VISIBLE_TOP, SET_NAVIGATION_APP, SET_DEBUG, SET_SHARE_WECHAT } from './mutationTypes';

export default createStore({
  state: {
    debug: false,
    title: '',
    audio: { src: '' },
    visibleTop: false,
    visibleApp: false,
    // 显示顶部打开APP导航的路由
    visbleAppRouters: ['detail'],
    // 隐藏顶部打开APP导航的路由
    hideAppRouters: ['user-register-wechat', 'user-register', 'download', 'my-invite-download', 'member-sign', 'member-equity', 'member-rule', 'member-sign-rule'],
    // 隐藏tabbar的路由
    hideTopRouters: [],
    shareWechat: false,
  },
  getters: {},
  mutations: {
    // 设置标题
    [SET_TITLE](states, newValue) {
      Object.assign(states, { title: newValue });
      document.title = newValue || '';
      setTimeout(() => {
        // 兼容 appWebview监听history模式地址栏改变
        const origin = `${window.location.protocol}//${window.location.host}`;
        if (window.ReactNativeWebView) return window.ReactNativeWebView.postMessage(JSON.stringify({ length: window.history.length }));
        return window.postMessage(JSON.stringify({ length: window.history.length }), origin);
        // window.postMessage(window.history.length);
      });
    },
    // 头部标题栏
    [SET_VISIBLE_TOP](states, newValue) {
      Object.assign(states, { visibleTop: newValue });
    },
    // app导航
    [SET_NAVIGATION_APP](states, newValue) {
      Object.assign(states, { visibleApp: newValue });
    },
    [SET_DEBUG](states, newValue = false) {
      Object.assign(states, { debug: newValue });
    },
    [SET_SHARE_WECHAT](states, newValue = false) {
      Object.assign(states, { shareWechat: newValue });
    },
  },
  actions: {},
  modules: {
    user,
    serviceHappy,
    serviceRepair,
    yearReport,
    yearReport2022,
    yearReport2024,
    yearReport2025,
    invoice,
    unBind,
  },
});
